//@ts-nocheck
import React, { useEffect, useState } from "react";
import { CrossIcon } from "../../icons/Icons";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Listbox,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
} from "@headlessui/react";
import { UpdateJobApplicationByList } from "../../../features/ApplicationData/ApplicationDataSlice";
import { useAppDispatch } from "../../../app/hooks";
import { toast } from "sonner";
import ReviewOverview from "./ReviewOverview";
import ReviewResume from "./ReviewResume";
import ReviewQuestionnaireSection from "./ReviewQuestionnaireSection";
import ReviewQuestionSetDetails from "./ReviewQuestionSetDetails";
import CandidateReviewSecond from "./CandidateReviewSecond";
import { fetchAppReviewDetailsData } from "../../../features/AppReview/AppReviewSlice";
import ReviewMessageSection from "./ReviewMessageSection";
import ReviewJobTeamDiscussion from "./ReviewJobTeamDiscussion";
import ReviewNotesSection from "./ReviewNotesSection";
import JobScorecardsSection from "../JobScorecardsSection";

function classNames(...classes: any) {
  return classes.filter(Boolean).join(" ");
}

function CandidateReviewLayout({
  isOpenHeader,
  setIsOpenHeader,
  selectedFilterHeader,
  optionsWithAllStagesHeader,
  applicationDetails,
  setSelectedFilterHeader,
  setapplicationDetails,
  isConductReview,
  appreviewId,
  appreviewId1,
  QuestionsId,
  isLoadingApp,
  setIsLoadingApp,
}) {
  const { baseId, jobId, applicationId } = useParams<{
    baseId: string;
    jobId: string;
    applicationId: string;
  }>();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [activeStatus, setActiveStatus] = useState<
    "Overview" | "Resume" | "Questionnaire"
  >("Overview");
  const [activeStatus1, setActiveStatus1] = useState<
    "Review" | "Message" | "Team Discussion" | "Notes" | "scorecard"
  >("Review");
  const [meetingData, setMeetingData] = useState(null);
  const [loading, setLoading] = useState(false);

  // Handle back button click
  const handleBackClick = () => {
    navigate(
      `/${baseId}/job/${jobId}/app/${applicationId}/appreview/${appreviewId}`,
    );
  };

  const handleToggleHeader = () => {
    setIsOpenHeader(!isOpenHeader);
  };

  // Handle filter change
  const handleFilterChangeHeader = async (option) => {
    try {
      setSelectedFilterHeader(option);
      // Prepare payload
      const payload = {
        baseId,
        applicationId,
        stage_id: option.id,
      };
      // Dispatch API call
      const res = await dispatch(UpdateJobApplicationByList(payload)).unwrap();
      if (res?.status === 200) {
        toast.success("Stage id updated successfully");
      }
    } catch (error) {
      console.error("Error updating job application list:", error);
    }
  };
  const handleStatusDraft = () => {
    setIsLoadingApp(true);
    setActiveStatus("Overview");

    // Hide the spinner after 500ms
    setTimeout(() => {
      setIsLoadingApp(false);
    }, 500);

    // Navigate immediately
    navigate(
      `/${baseId}/job/${jobId}/app/${applicationId}/appreview/${appreviewId}/conduct-review`,
      { replace: true },
    );
  };

  const handleStatusPending = () => {
    setActiveStatus("Resume");
    navigate(
      `/${baseId}/job/${jobId}/app/${applicationId}/appreview/${appreviewId}/conduct-review`,
      { replace: true },
    );
  };

  const handleStatusCompleted = () => {
    setActiveStatus("Questionnaire");
  };

  const handleReviewStatus = () => {
    setActiveStatus1("Review");
    navigate(
      `/${baseId}/job/${jobId}/app/${applicationId}/appreview/${appreviewId}/conduct-review`,
      { replace: true },
    );
  };

  const handleStatusMessage = () => {
    setActiveStatus1("Message");
    navigate(
      `/${baseId}/job/${jobId}/app/${applicationId}/appreview/${appreviewId}/conduct-review`,
      { replace: true },
    );
  };

  const handleStatusTeamDiscussion = () => {
    setActiveStatus1("Team Discussion");
    navigate(
      `/${baseId}/job/${jobId}/app/${applicationId}/appreview/${appreviewId}/conduct-review`,
      { replace: true },
    );
  };

  const handleStatusNotes = () => {
    setActiveStatus1("Notes");
    navigate(
      `/${baseId}/job/${jobId}/app/${applicationId}/appreview/${appreviewId}/conduct-review`,
      { replace: true },
    );
  };

  const handleScorecard = () => {
    setActiveStatus1("scorecard");
    navigate(
      `/${baseId}/job/${jobId}/app/${applicationId}/appreview/${appreviewId}/conduct-review`,
      { replace: true },
    );
  };

  useEffect(() => {
    const fetchMeetingDetails = async () => {
      if (baseId) {
        setLoading(true);
        try {
          const res = await dispatch(
            fetchAppReviewDetailsData({
              baseId: Number(baseId),
              id: appreviewId,
            }),
          ).unwrap();
          if (res.status === 200) {
            setMeetingData(res.data);
          }
        } catch (error) {
          console.error("Error fetching mting details:", error);
          // setError("Failed to load meeting details");
        } finally {
          setLoading(false);
        }
      }
    };

    fetchMeetingDetails();
  }, [baseId, dispatch, appreviewId]);

  return (
    <div>
      <div className="h-screen overflow-hidden">
        {/* Header */}
        <div className="sticky top-0" style={{ zIndex: 10 }}>
          <div className="flex h-[56px] shrink-0 items-center gap-x-4 bg-white px-4 shadow-custom-1 sm:gap-x-6 sm:px-6 lg:px-4">
            <div className="flex items-center gap-x-2">
              <span
                className="table-tooltip before:!bottom-[-32px] before:!left-[17px]"
                data-title="back"
              >
                <button
                  className=" relative inline-flex hover:bg-[#f4f4f5] items-center justify-center whitespace-nowrap rounded-lg text-sm font-medium transition-colors outline-offset-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring/70 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 border border-input bg-background shadow-sm shadow-black/5 hover:bg-accent hover:text-accent-foreground h-8 w-8"
                  onClick={handleBackClick}
                >
                  <CrossIcon />
                </button>
              </span>
            </div>

            {/* <div className="h-6 w-px bg-gray-900/10" aria-hidden="true" /> */}

            <div className="flex items-center justify-between w-full">
              <div className="flex items-center gap-x-4">
                <div className="flex items-center gap-x-2">
                  <div className="flex items-center gap-x-2">
                    {applicationDetails ? (
                      <>
                        <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border-none text-[0.625rem] font-medium text-white capitalize bg-gray-400">
                          {applicationDetails?.application?.app_name?.charAt(0)}
                        </div>
                        <div className="flex flex-col gap-y-[1px]">
                          <span className="text-black-100 font-semibold text-sm capitalize line-clamp-1">
                            {applicationDetails?.application?.app_name}
                          </span>
                          <span className="text-[#1b1b1b] leading-4 text-[12px] font-normal line-clamp-1 w-[155px]">
                            {applicationDetails?.application?.app_headline ||
                              applicationDetails?.application?.app_email}
                          </span>
                        </div>
                      </>
                    ) : (
                      <>
                        {/* Skeleton for job title */}
                        <div className="h-7 w-7 bg-gray-300 animate-pulse rounded-full"></div>
                        <div className="w-24 h-4 bg-gray-300 animate-pulse rounded"></div>
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-x-4">
                <div
                  data-title="Change Stage"
                  className="max-w-[140px] min-w-[140px] w-full table-tooltip before:!bottom-[-32px] before:!left-[54px]"
                >
                  <div
                    onClick={handleToggleHeader}
                    className=" w-full inline-flex items-center justify-start whitespace-nowrap rounded-lg text-sm font-medium transition-colors outline-offset-2
                             focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring/70 disabled:pointer-events-none disabled:opacity-50 
                             [&_svg]:pointer-events-none [&_svg]:shrink-0 border border-input bg-background shadow-sm shadow-black/5 hover:bg-accent hover:text-accent-foreground h-8 px-2  py-2"
                  >
                    <Listbox
                      value={selectedFilterHeader}
                      onChange={handleFilterChangeHeader}
                    >
                      <div className="relative mt-0 w-full">
                        <ListboxButton className="relative w-full bg-transparent flex items-center justify-between p-0 cursor-pointer rounded-md text-left text-gray-900 border-none">
                          <div className="flex items-center gap-x-[6px]">
                            {selectedFilterHeader?.stage_colour && (
                              <span
                                className="flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-[2px] 
                                        border-none text-[0.625rem] font-medium text-white capitalize"
                                style={{
                                  background:
                                    selectedFilterHeader?.stage_colour,
                                }}
                              ></span>
                            )}
                            {selectedFilterHeader?.stage_name && (
                              <span className="block truncate text-[#1b1b1b] font-normal">
                                {selectedFilterHeader?.stage_name}
                              </span>
                            )}
                          </div>

                          <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={24}
                              height={24}
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-down w-[1rem] h-[1rem] text-[#808080]"
                            >
                              <path
                                stroke="none"
                                d="M0 0h24v24H0z"
                                fill="none"
                              />
                              <path d="M6 9l6 6l6 -6" />
                            </svg>
                          </span>
                        </ListboxButton>

                        <ListboxOptions className="absolute z-10 mt-[9px] left-[-17px] bg-white max-w-[140px] min-w-[140px] w-full overflow-hidden rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 ">
                          {optionsWithAllStagesHeader.map((option) => (
                            <ListboxOption
                              key={option.id}
                              value={option}
                              className={({ active }) =>
                                classNames(
                                  active
                                    ? "bg-gray-200 text-[#1d2025]"
                                    : "text-gray-900",
                                  "relative flex select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 cursor-pointer",
                                )
                              }
                            >
                              {({ selected, active }) => (
                                <>
                                  <div className="flex items-center justify-between">
                                    <div className="flex items-center gap-x-[6px]">
                                      <span
                                        className="flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-[2px] 
                                              border-none text-[0.625rem] font-medium text-white capitalize"
                                        style={{
                                          background: option?.stage_colour,
                                        }}
                                      ></span>
                                      <span
                                        className={classNames(
                                          selected
                                            ? "font-semibold"
                                            : "font-normal",
                                          "block truncate",
                                        )}
                                      >
                                        {option.stage_name}
                                      </span>
                                    </div>
                                  </div>
                                  {selected ? (
                                    <span
                                      className={classNames(
                                        active ? "text-white" : "text-gray-600",
                                        "absolute inset-y-0 right-0 flex items-center pr-4",
                                      )}
                                    ></span>
                                  ) : null}
                                </>
                              )}
                            </ListboxOption>
                          ))}
                        </ListboxOptions>
                      </div>
                    </Listbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex h-[calc(100vh-56px)]">
          <div className="flex justify-center w-full">
            <div className="w-[50%] border-r border-gray-200 h-[calc(100vh_-_56px)] overflow-auto">
              <div className="flex items-center justify-center ml-[0px] pt-6 pb-4 px-4">
                <button
                  className={`px-[6px] md:px-2 lg:px-2 text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] leading-[1.2] font-semibold py-[5px]
                  border border-r-0 border-solid border-[rgba(0, 0, 0, 0.08)] rounded-tl-md rounded-bl-md ${activeStatus === "Overview" ? "bg-[#6b7280] text-white  border-[#6b7280]" : "bg-[#f9fafa] text-[#0000007a] hover:text-black-100"}`}
                  onClick={handleStatusDraft}
                >
                  Overview
                </button>
                <button
                  className={`px-[6px] md:px-2 lg:px-2 text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] leading-[1.2] font-semibold py-[5px] 
                    border border-r-0 border-solid border-[rgba(0, 0, 0, 0.08)]  ${activeStatus === "Resume" ? "bg-[#6b7280] text-white border-[#6b7280]" : "bg-[#f9fafa] text-[#0000007a] hover:text-black-100"}`}
                  onClick={handleStatusPending}
                >
                  Resume
                </button>
                <button
                  className={`px-[6px] md:px-2 lg:px-2 text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] leading-[1.2] font-semibold py-[5px] border
               border-solid border-[rgba(0, 0, 0, 0.08)] rounded-tr-md rounded-br-md ${activeStatus === "Questionnaire" ? "bg-[#6b7280] text-white border-[#6b7280]" : "bg-[#f9fafa] text-[#0000007a] hover:text-black-100"}`}
                  onClick={handleStatusCompleted}
                >
                  Questionnaire
                </button>
              </div>
              <div className="w-full m-auto max-w-[640px] pt-2 pb-8">
                <div className="flex-grow">
                  {activeStatus === "Overview" && (
                    <div className="w-full h-full">
                      {isLoadingApp ? (
                        <div className="flex items-center justify-center h-[calc(100vh_-_56px)] w-full bg-white">
                          <div className="simple-spinner-loader">
                            <span></span>
                          </div>
                        </div>
                      ) : (
                        <ReviewOverview
                          applicationDetails={applicationDetails}
                          setapplicationDetails={setapplicationDetails}
                          isConductReview={isConductReview}
                        />
                      )}
                    </div>
                  )}
                  {activeStatus === "Resume" && (
                    <div className="w-full h-full pt-2 pb-8">
                      <ReviewResume
                        resumeData={applicationDetails?.application?.app_resume}
                      />
                    </div>
                  )}

                  {activeStatus === "Questionnaire" && (
                    <div className="w-full h-full pt-2 pb-8">
                      {appreviewId1 ? (
                        <div className="w-full max-w-[640px] m-auto">
                          <Link
                            to={`/${baseId}/job/${jobId}/app/${applicationId}/appreview/${appreviewId}/conduct-review`}
                            className="flex items-center gap-x-1 w-full mb-4 ml-[-4px]"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={24}
                              height={24}
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-left w-[0.9rem] h-[0.9rem]"
                            >
                              <path
                                stroke="none"
                                d="M0 0h24v24H0z"
                                fill="none"
                              />
                              <path d="M15 6l-6 6l6 6" />
                            </svg>
                            <span className="text-black-100 text-[13px]">
                              Back to Questionnaire
                            </span>
                          </Link>
                          <ReviewQuestionSetDetails QuestionsId={QuestionsId} />
                        </div>
                      ) : (
                        <ReviewQuestionnaireSection appreviewId={appreviewId} />
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="w-[50%]">
              <div className="flex items-center justify-center ml-[0px] pt-6 pb-4 px-4">
                <button
                  className={`px-[6px] md:px-2 lg:px-2 text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] leading-[1.2] font-semibold py-[5px]
               border border-r-0 border-solid border-[rgba(0, 0, 0, 0.08)] rounded-tl-md rounded-bl-md ${activeStatus1 === "Review" ? "bg-[#6b7280] text-white  border-[#6b7280]" : "bg-[#f9fafa] text-[#0000007a] hover:text-black-100"}`}
                  onClick={handleReviewStatus}
                >
                  Review
                </button>
                <button
                  className={`px-[6px] md:px-2 lg:px-2 text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] leading-[1.2] font-semibold py-[5px] 
                    border border-r-0 border-solid border-[rgba(0, 0, 0, 0.08)]  ${activeStatus1 === "Message" ? "bg-[#6b7280] text-white border-[#6b7280]" : "bg-[#f9fafa] text-[#0000007a] hover:text-black-100"}`}
                  onClick={handleStatusMessage}
                >
                  Message
                </button>
                <button
                  className={`px-[6px] md:px-2 lg:px-2 text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] leading-[1.2] font-semibold py-[5px] 
                    border border-r-0 border-solid border-[rgba(0, 0, 0, 0.08)] ${activeStatus1 === "Team Discussion" ? "bg-[#6b7280] text-white border-[#6b7280]" : "bg-[#f9fafa] text-[#0000007a] hover:text-black-100"}`}
                  onClick={handleStatusTeamDiscussion}
                >
                  Team Discussion
                </button>
                <button
                  className={`px-[6px] md:px-2 lg:px-2 text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] leading-[1.2] font-semibold py-[5px] 
                    border border-r-0 border-solid border-[rgba(0, 0, 0, 0.08)] ${activeStatus1 === "Notes" ? "bg-[#6b7280] text-white border-[#6b7280]" : "bg-[#f9fafa] text-[#0000007a] hover:text-black-100"}`}
                  onClick={handleStatusNotes}
                >
                  Notes
                </button>
                <button
                  className={`px-[6px] md:px-2 lg:px-2 text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] leading-[1.2] font-semibold py-[5px] border
               border-solid border-[rgba(0, 0, 0, 0.08)] rounded-tr-md rounded-br-md ${activeStatus1 === "scorecard" ? "bg-[#6b7280] text-white border-[#6b7280]" : "bg-[#f9fafa] text-[#0000007a] hover:text-black-100"}`}
                  onClick={handleScorecard}
                >
                  Scorecard
                </button>
              </div>
              <div className="flex-grow">
                <div className="h-[calc(100vh_-_124px)] overflow-auto">
                  <div className="w-full m-auto max-w-[640px] pt-2 pb-8">
                    {activeStatus1 === "Review" && (
                      <div className="w-full h-full">
                        <CandidateReviewSecond
                          meetingData={meetingData}
                          loading1={loading}
                        />
                      </div>
                    )}
                    {activeStatus1 === "Message" && (
                      <div className="w-full h-full pt-2 pb-8">
                        <ReviewMessageSection />
                      </div>
                    )}
                    {activeStatus1 === "Team Discussion" && (
                      <div className="w-full h-full pt-2 pb-8">
                        <ReviewJobTeamDiscussion />
                      </div>
                    )}
                    {activeStatus1 === "Notes" && (
                      <div className="w-full h-full pt-2 pb-8">
                        <ReviewNotesSection />
                      </div>
                    )}
                    {activeStatus1 === "scorecard" && (
                      <div className="w-full h-full pt-2 pb-8">
                        <JobScorecardsSection />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CandidateReviewLayout;
